import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHeader from './TableHeader'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import TablePagniationActions from './TablePaginationActions'
import { FilledInput, Paper, TablePagination } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import DownloadComponent from '../downloadComponent/downloadComponent'
import PopoverComponent from '../PopoverComponent/PopoverComponent'
import PopoverFavComponent from '../PopoverFavComponent/PopoverFavComponent'
import PopoverBMComponent from '../PopoverFavComponent/PopoverBMComponent'
import BookmarkComponent from '../BookmarkComponent/BookmarkComponent'
import Select from '@mui/material/Select'
import NativeSelect from '@mui/material/NativeSelect'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import './Table.scss'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-body': {
    fontSize: 13,
    fontStyle: 'Regular',
    color: '#333333',
    fontFamily: 'Noto Sans',
    textAlign: 'left'
  }
}))

function renderCells (row: any[], isAdmin: boolean, isInternal: boolean, em: string | undefined, eid: string | undefined) {
  return row.map((values: any, index: number) => {
    // Index updated to pass report Id as index
    if (values === 'default') {
      values = <PopoverComponent userTypeName={isInternal ? row[7] : row[6]} isInternal={isInternal} isAdmin={isAdmin} index={isInternal ? row[2] : row[7]} />
    } else if (values === 'download') {
      values = <DownloadComponent index={row[0]} report={row} em={em} e_id={eid} isInternal={isInternal}/>
    } if (values === 'CheckFav') {
      values = <PopoverFavComponent userTypeName={isInternal ? row[7] : row[6]} isInternal={isInternal} isAdmin={isAdmin} index={isInternal ? row[8] : row[1]} />
    } if (values === 'RemoveBM') {
      values = <PopoverBMComponent userTypeName={isInternal ? row[7] : row[6]} isInternal={isInternal} isAdmin={isAdmin} index={isInternal ? row[8] : row[1]} />
    } if (index === 12) {
      return (null)
    } else if (index === 13) {
      return (null)
    }
    return (<StyledTableCell className={index === row.length - 1 ? 'action-column' : ''} component={'td'} scope="row" key={index}>
            {values}
        </StyledTableCell>)
  })
}
function renderBody (list: any[], isAdmin: boolean, isInternal: boolean, em: string | undefined, eid: string | undefined) {
  return list.map((row: any, index: number) => {
    return <TableRow key={index}>{renderCells(Object.values(row), isAdmin, isInternal, em, eid)}</TableRow>
  })
}

function getComparator (order: string, orderBy: string) {
  return order === 'desc'
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy)
}

function stableSort (array: any[], comparator: any) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

function descendingComparator (a: any, b: any, orderBy: string) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

interface Props {
  data: any[]
  columnNames: string[]
  class?: string
  rowperpage?: number
  em?: string
  e_id?: string
  isInternal?: boolean
}

export default function TableComponent (props: Props) {
  const [list, setreportList] = useState<any[]>(props.data)
  const [headers, setheaders] = useState<string[]>(props.columnNames)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(props.rowperpage || 5)
  const [order, setorder] = useState<'asc' | 'desc'>('asc')
  const [orderBy, setorderBy] = useState<string>('')
  const isAdmin = useSelector((state: any) => state.reducers.isAdmin)
  const isInternal = useSelector((state: any) => state.reducers.isInternal)
  useEffect(() => {
    setreportList(props.data)
    setPage(0)
  }, [props.data])

  useEffect(() => {
    setRowsPerPage(props.rowperpage || 5)
  }, [props.rowperpage])

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(String(event.target.value), 10))
    setPage(0)
  }

  const handleRequestSort = (event: unknown, property: string) => {
    if (property !== '') {
      const isAsc = orderBy === property && order === 'asc'
      setorder(isAsc ? 'desc' : 'asc')
      setorderBy(property)
    }
  }

  function onButtonChange (event: unknown, pageNum: number) {
    setPage(pageNum - 1)
  }

  return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 800 }} className={props.class || ''} aria-label="dashboard table">
                <TableHeader
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={list.length}
                    headers={headers}
                />

                <TableBody>
                    {renderBody(stableSort(list, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), isAdmin, isInternal, props.em, props.e_id)}
                </TableBody>
                <TableFooter>
                    <TableRow>
                    <td colSpan={headers.length}>
                      <div className='table-pagination-footer'>
                        <span className='total-records'>Total Records: {list.length}</span>
                        <Pagination count={Math.ceil(list.length / rowsPerPage)} color='primary' onChange={(e, page) => onButtonChange(e, page)}/>
                        <FormControl variant='outlined'>
                          <NativeSelect value = {rowsPerPage} onChange = {handleChangeRowsPerPage}>
                            <option value={5}>Show 5 results per page</option>
                            <option value={10}>Show 10 results per page</option>
                            <option value={20}>Show 20 results per page</option>
                            <option value={30}>Show 30 results per page</option>
                          </NativeSelect>
                        </FormControl>
                      </div>
                    </td>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
  )
}
